import { render, staticRenderFns } from "./MotoMediumSize.vue?vue&type=template&id=2cc69df8&"
import script from "./MotoMediumSize.vue?vue&type=script&lang=js&"
export * from "./MotoMediumSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports